import React from 'react'
import { Navigate } from 'react-router-dom'

const PrivateRoute = ({element,requiredPermission}) => {
    const token = localStorage.getItem('token')
    if(!token){
        return  <Navigate to='/login' replace />
    }
    const userData = JSON.parse(atob(token.split('.')[1]));
    const userPermission = userData.privelege || [];
 
    if(requiredPermission && !requiredPermission.some(permi=>userPermission.includes(permi))){
        return <Navigate to='/' replace />
    }
    return element
}

export default PrivateRoute